import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'ngx-auth-popup',
  templateUrl: './auth-popup.component.html',
  styleUrls: ['./auth-popup.component.scss'],
})
export class AuthPopupComponent implements OnInit, OnDestroy {
  @Input() isResetPassword: boolean;
  @Input() isForgotPassword: boolean;

  constructor(public activeModal: NgbActiveModal,
              private router: Router,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.isForgotPassword = this.router.url === '/auth/forgot-password';
    if (!this.isResetPassword) {
    	this.isResetPassword = this.router.url.toString().includes('/auth/reset-password');
    }
    this.router.events
      .pipe(filter(event => {
        return (event instanceof NavigationEnd);
      }))
      .subscribe((route: RouterEvent) => {
        this.isForgotPassword = route.url === '/auth/forgot-password';
        this.isResetPassword = route.url.toString().includes('/auth/reset-password');
        if (route.url === '/auth/login') {
          this.isForgotPassword = false;
          this.isResetPassword = false;
        }
      });
  }

  ngOnDestroy() {
    this.router.navigate(['/']);
  }

}
